import type { CogniteClient } from '@cognite/sdk';
import { createContext } from 'react';

export const CogniteClientContext = createContext<CogniteClient | null>(null) as React.Context<CogniteClient>;
